export const nav = {
    permissao: "lpbuilder.versoes:editar",
    section: "LPBuilder",
    title: "Builder",
    icon: "dashboard_customize",
    route: "/projetos",
    sequence: 2,
    dontshow: true,
};

export default [
    {
        path: "/projetos/:projetoUuid/versoes/:versaoUuid/builder",
        name: "lpbuilder-builder",
        component: () => import("./pages/BuilderPage.vue"),
        props: true,
        meta: {
            requiresAuth: true,
            permissoesAlguma: [
                "lpbuilder.versoes:visualizar",
                "lpbuilder.versoes:editar",
            ],
        },
    },
    {
        path: "/projetos/:projetoUuid/publicacoes/:deployUuid/preview",
        name: "lpbuilder-deploy-preview",
        component: () => import("./pages/BuilderPage.vue"),
        props: (route) => ({ previewDeployUuid: route.params.deployUuid }),
        meta: { requiresAuth: true, permissao: "lpbuilder.deploys:visualizar" },
    },
];
